import { render, staticRenderFns } from "./UpdateEntity.vue?vue&type=template&id=090c7ca6"
import script from "./UpdateEntity.vue?vue&type=script&lang=js"
export * from "./UpdateEntity.vue?vue&type=script&lang=js"
import style0 from "./UpdateEntity.vue?vue&type=style&index=0&id=090c7ca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports